/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  SpendRuleTargetCondition,
  SpendRuleTargetCondition$Outbound,
  SpendRuleTargetCondition$outboundSchema,
} from "./spendruletargetcondition.js";

/**
 * UTC calendar window to compute spend over.
 */
export const PreviewSpendRuleRequestBodyWindowKind = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
} as const;
/**
 * UTC calendar window to compute spend over.
 */
export type PreviewSpendRuleRequestBodyWindowKind = ClosedEnum<
  typeof PreviewSpendRuleRequestBodyWindowKind
>;

export type PreviewSpendRuleRequestBody = {
  /**
   * Per-person budget in USD used to compute usage percentages.
   */
  limitUsd: number;
  target: SpendRuleTargetCondition;
  /**
   * Percentage of the limit at which a warning event is emitted.
   */
  warnAtPct?: number | undefined;
  /**
   * UTC calendar window to compute spend over.
   */
  windowKind: PreviewSpendRuleRequestBodyWindowKind;
};

/** @internal */
export const PreviewSpendRuleRequestBodyWindowKind$outboundSchema:
  z.ZodMiniEnum<typeof PreviewSpendRuleRequestBodyWindowKind> = z.enum(
    PreviewSpendRuleRequestBodyWindowKind,
  );

/** @internal */
export type PreviewSpendRuleRequestBody$Outbound = {
  limit_usd: number;
  target: SpendRuleTargetCondition$Outbound;
  warn_at_pct: number;
  window_kind: string;
};

/** @internal */
export const PreviewSpendRuleRequestBody$outboundSchema: z.ZodMiniType<
  PreviewSpendRuleRequestBody$Outbound,
  PreviewSpendRuleRequestBody
> = z.pipe(
  z.object({
    limitUsd: z.number(),
    target: SpendRuleTargetCondition$outboundSchema,
    warnAtPct: z._default(z.int(), 80),
    windowKind: PreviewSpendRuleRequestBodyWindowKind$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      limitUsd: "limit_usd",
      warnAtPct: "warn_at_pct",
      windowKind: "window_kind",
    });
  }),
);

export function previewSpendRuleRequestBodyToJSON(
  previewSpendRuleRequestBody: PreviewSpendRuleRequestBody,
): string {
  return JSON.stringify(
    PreviewSpendRuleRequestBody$outboundSchema.parse(
      previewSpendRuleRequestBody,
    ),
  );
}
